import React from 'react';
import { Typography } from 'seagull';
import { approvalMethodNoticePeriodModel, relationshipModel } from "../../../../models";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
import { getAmendmentsApprovalMethodChangeBullet } from "../../../../business-logic/amendmentsLogic";
import styles from "./AgreementAmendmentsApprovalMethod.module.scss";
export default function AgreementAmendmentsApprovalMethod(props) {
  const {
    relationship,
    testid
  } = props;
  const updated = relationshipModel.updatedAmendmentsApprovalMethod(relationship);
  const actual = relationshipModel.actualAmendmentsApprovalMethod(relationship);
  const isAutoApproval = approvalMethodNoticePeriodModel.isAutoApproval(actual);
  const changeBullet = updated ? getAmendmentsApprovalMethodChangeBullet(relationship.amendmentsApprovalMethod, updated.value) : null;
  return isAutoApproval || updated ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    weight: "bold"
  }, "Amendments"), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid + 'notice-period'
  }, approvalMethodNoticePeriodModel.amendmentsDescription(actual)), changeBullet && /*#__PURE__*/React.createElement("div", {
    className: styles.changes
  }, /*#__PURE__*/React.createElement(AmendmentChangesInAgreementView, {
    disableBorderRadius: true,
    items: [changeBullet],
    autoApprovalDate: relationshipModel.updatedAmendmentsApprovalMethodAutoApprovalDate(relationship),
    testid: testid + 'notice-changes'
  }))) : null;
}